import type { components } from "@/shared/api";

type MatchList = components["schemas"]["MatchListOut"];

// Бэкенд ставит загрузку истории матчей из deadlock-api и отвечает тем, что уже есть
// в базе, с флагом `history_sync_pending`. Пока флаг стоит, перезапрашиваем список
// раз в 5 секунд, но не дольше 2 минут. Список при этом может быть не пустым: матчи
// игрока попадают в базу и из чужих разборов (#46). Каждый запрос читает только базу,
// а в deadlock-api бэкенд ходит не чаще раза в 10 минут на игрока.
export const HISTORY_POLL_INTERVAL_MS = 5_000;
export const HISTORY_POLL_MAX_FETCHES = 24;

// Загрузка истории идёт, и лимит перезапросов не исчерпан.
// `fetchCount` — число успешных ответов (`dataUpdateCount` в состоянии запроса).
export const isHistorySyncing = (data: MatchList | undefined, fetchCount: number): boolean =>
  data?.history_sync_pending === true && fetchCount < HISTORY_POLL_MAX_FETCHES;

// Показать заглушку «загружаем историю»: загрузка идёт, а показать пока нечего.
export const isWaitingForHistory = (data: MatchList | undefined, fetchCount: number): boolean =>
  isHistorySyncing(data, fetchCount) && data?.items.length === 0;
